module.exports = __webpack_public_path__ + "img/banner_info.a6acdfc5.png";